import { call, put, takeLatest } from "redux-saga/effects";
import { getDashboardStatsApi } from "../../../../api/dashboard";
import { IBaseResponse } from "../../../../interfaces/base";
import { IFetchDashboardAction } from "../../../../interfaces/store/dashboard-interface";
import {
  getDashboardStatsSuccess,
  getDashboardStatsFailed,
  getDashboardStatsStart,
} from "./stats-slice";

function* _getDashboardStats({ payload }: IFetchDashboardAction) {
  try {
    const { trainerId } = payload;
    const response: IBaseResponse = yield call(getDashboardStatsApi, trainerId);

    if (response.error) {
      yield put(getDashboardStatsFailed(response.error));
    } else {
      yield put(
        getDashboardStatsSuccess({
          data: response.data,
        })
      );
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(getDashboardStatsFailed({ message: error.message }));
  }
}

function* dashboardStatsSaga() {
  yield takeLatest(getDashboardStatsStart.type, _getDashboardStats);
}

export default dashboardStatsSaga;
